import * as React from 'react';
import type { InjectedRouter } from 'react-router';

import PropTypes from 'prop-types';
import { compose } from 'recompose';
import type { LegacyContextType } from 'types/legacy-context-types';

import Retracked from 'js/app/retracked';
import connectToStores from 'js/lib/connectToStores';

import DefaultHeader from 'bundles/composable-page-header-consumer/header-renderers/DefaultHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import ApplicationStoreClass from 'bundles/ssr/stores/ApplicationStore';

import 'css!bundles/collections/styl/index';

type Props = {
  requestCountryCode?: string;
  csrfToken?: string;
  children?: JSX.Element;
};

type Context = {
  router: InjectedRouter;
  getStore: (storeName: string) => any;
};

class CollectionsApp extends React.Component<Props> {
  static propTypes = {
    requestCountryCode: PropTypes.string,
    csrfToken: PropTypes.string,
    children: PropTypes.node,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
    getStore: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof CollectionsApp.contextTypes>;

  static childContextTypes = {
    csrfToken: PropTypes.string,
    requestCountryCode: PropTypes.string,
  };

  constructor(props: Props, context: Context) {
    super(props);
  }

  getChildContext() {
    const { csrfToken, requestCountryCode } = this.props;
    return {
      csrfToken,
      requestCountryCode,
    };
  }

  render() {
    const { children } = this.props;

    return (
      <div className="rc-CollectionsApp">
        <UniversalPageFeatures />
        <DefaultHeader showMetaNav />
        {children}
        <PageFooter />
      </div>
    );
  }
}

export default compose<{}, Props>(
  connectToStores<Props, Omit<Props, 'csrfToken' | 'requestCountryCode'>>(
    [ApplicationStoreClass],
    (ApplicationStore, props) => ({
      ...props,
      csrfToken: ApplicationStore.getState().csrfToken,
      requestCountryCode: ApplicationStore.getState().requestCountryCode,
    })
  ),
  Retracked.createTrackedContainer(() => {
    return {
      namespace: {
        page: 'collections_page',
        app: 'collections',
      },
    };
  })
)(CollectionsApp);
